import { render, staticRenderFns } from "./Referrer.vue?vue&type=template&id=1ba8131b"
import script from "./Referrer.vue?vue&type=script&setup=true&lang=js"
export * from "./Referrer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports